import { AnimatePresence } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../../../../lib/hooks'

import Button from '@/components/Button'
import Modal from '@/components/Modal'


import useCheckout from '../../hooks/useCheckout'
import Step from '../Step/Step'
import { PaymentFooter, PaymentOptions, PaymentTotal, PaymentWrapper } from './Payment.styles'
import PaymentOption from './PaymentOption'

const Payment = () => {
  const { t } = useTranslation()
  const { cartTotal, paymentMethod, setPaymentMethod, setCurrentStep, setPaymentError, setPaymentStatus, paymentStatus, setAssistance } =
    useCheckout()
  const [isLoading, setIsLoading] = useState(false)
  const [paymentMessage, setPaymentMessage] = useState('')
  const themes = useTheme()

  const handlePayment = () => {
    setIsLoading(true)

    if (paymentMethod === 'CARD') {
      try {
        setPaymentStatus('PENDING')
        window.BtDevice.startPayment(cartTotal)
      } catch (error) {
        console.error('[DEVICE] startPayment error', error)
        setPaymentError('Device error occured...')
        setPaymentStatus('ERROR')
        setTimeout(() => {
          setIsLoading(false)
          setCurrentStep('CONFIRMATION')
          setAssistance(true)
          setTimeout(() => {
            setAssistance(false)
          }, 30000)
        }, 1000)
      }
    } else {
      setPaymentStatus('COMPLETE')
      setCurrentStep('CONFIRMATION')
      setIsLoading(false)
      setAssistance(false)
      window.BtDevice.cashPayment(cartTotal)
    }
  }

  const methods = [
    {
      icon: 'card',
      name: 'CARD',
      title: t('creditCard')
    },
    {
      icon: 'cash',
      name: 'CASH',
      title: t('cash')
    }
  ]

  useEffect(() => {
    if (window.BtApp) {
      window.BtApp.paymentFinished = (code, msg) => {
        console.log('[APP] paymentFinished', code, msg)
        if (Number(code) !== 0) {
          setPaymentError(msg)
          setAssistance(true)
          setTimeout(() => {
            setAssistance(false)
          }, 30000)
        } else {
          setPaymentError(null)
          setAssistance(false)
        }
        setCurrentStep('CONFIRMATION')
        setPaymentStatus('COMPLETE')
      }

      window.BtApp.paymentStatus = statusMessage => {
        setPaymentMessage(statusMessage)
      }
    }
  }, [])

  return (
    <Step>
      <PaymentWrapper>
        <PaymentTotal>
          <h3>{t('totalToPay')}</h3>
          {themes.currency === '€' ? <h2>
            {themes.currency}
            {cartTotal.toFixed(2)}
          </h2> : <h2>
            {cartTotal.toFixed(2)} {themes.currency}
          </h2>}
        </PaymentTotal>
        <PaymentOptions>
          <h2>{t('selectPaymentMethod')}</h2>
          {methods.map(({ icon, name, title }) => (
            <PaymentOption key={name} onClick={() => setPaymentMethod(name)} icon={icon} active={paymentMethod === name}>
              {title}
            </PaymentOption>
          ))}
        </PaymentOptions>
        <PaymentFooter>
          <Button block={true} onClick={() => handlePayment()} isLoading={isLoading}>
            {t('payNow')}
          </Button>
          <Button block={true} variant="secondary" onClick={() => setCurrentStep('CART')}>
            {t('back')}
          </Button>
        </PaymentFooter>
        <AnimatePresence>
          {paymentStatus === 'PENDING' && (
            <Modal icon="terminal">
              <h3>{t('followTerminalInstructions')}</h3>
              <h3 style={{ fontWeight: 300 }}>{paymentMessage || ''}</h3>
            </Modal>
          )}
        </AnimatePresence>
      </PaymentWrapper>
    </Step>
  )
}

export default Payment
